import { CSVLink as CSVLinkOriginal } from "react-csv";
import exportCSV from "assets/icons/exportcsv.svg";

const CSVLink = CSVLinkOriginal as any;

interface CommonCSVExportProps {
  data: any[];
  headers: any[];
  filename: string;
  onClick?: () => void;
}

export default function CommonCSVExport({
  data,
  headers,
  filename,
  onClick,
}: CommonCSVExportProps) {
  return (
    <CSVLink
      data={data}
      headers={headers}
      filename={filename}
      className="export-btn"
      title="Download CSV file"
    >
      <img src={exportCSV} alt="" className="action-icons" onClick={onClick} />
    </CSVLink>
  );
}
